import { Component, inject, input, output, signal } from '@angular/core';
import { CdkDragEnd, DragDropModule } from '@angular/cdk/drag-drop';
import { Marker } from '../../models/classes/marker';
import { I18nService } from '../../services/i18n.service';
import { UiService } from '../../services/ui.service';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { GLOBAL_CONSTANT } from '../../constants/global.constant';

@Component({
  selector: 'app-dragdrop-marker-image',
  templateUrl: './drag-marker.html',
  styleUrls: ['./drag-marker.scss'],
  imports: [DragDropModule, NzFormModule, NzImageModule, NzIconModule],
})
export class DragMarkerImageComponent {
  // --- Services ---
  public i18n = inject(I18nService);
  private ui = inject(UiService);

  // --- Signal Inputs ---
  image = input.required<any>();
  markers = input<Marker[]>([]);
  wide = input<boolean>(false);
  imageOnLoad = output<Event>();
  imageLoaded = signal(false);
  clientWidth = signal(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  clientHeight = signal(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  naturalWidth = signal(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  naturalHeight = signal(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);

  // --- Computed State ---
  isMobile = this.ui.IsMobile;

  public getDragPosition(marker: Marker) {
    if (this.imageLoaded()) {
      return {
        x: marker.getClientX(
          this.clientWidth(),
          this.clientHeight(),
          this.naturalWidth(),
          this.naturalHeight()
        ),
        y: marker.getClientY(
          this.clientWidth(),
          this.clientHeight(),
          this.naturalWidth(),
          this.naturalHeight()
        ),
      };
    }
    return { x: 100, y: 100 };
  }

  public onDragEnded(marker: Marker, event: CdkDragEnd): void {
    if (this.imageLoaded()) {
      const cw = this.clientWidth();
      const ch = this.clientHeight();
      const nw = this.naturalWidth();
      const nh = this.naturalHeight();

      const x = marker.getClientX(cw, ch, nw, nh) + event.distance.x;
      const y = marker.getClientY(cw, ch, nw, nh) + event.distance.y;

      marker.setClientX(x, cw, ch, nw, nh);
      marker.setClientY(y, cw, ch, nw, nh);
    }
  }

  onImageLoaded(event: Event) {
    const target = event.target as HTMLImageElement;
    this.clientWidth.set(target.clientWidth);
    this.clientHeight.set(target.clientHeight);
    this.naturalWidth.set(target.naturalWidth);
    this.naturalHeight.set(target.naturalHeight);
    this.imageLoaded.set(true);
    this.imageOnLoad.emit(event);
  }
}
